import { useContext } from '@nuxtjs/composition-api'

// Composables
import useAnalytics from '@/composables/analytics/useAnalytics'

// Types
import { ImageEnhancementModalOptionsInterface } from '@/types/analytics/productAnalyticsTypes'

export default () => {
  const context = useContext()
  const analytics = useAnalytics()

  /*
    Track behavior in the image enhancement modal
  */
  const trackImageEnhancement = (options: ImageEnhancementModalOptionsInterface) => {
    const params = {
      event: 'image_enhancement_modal',
      openFromPanelBuilder: options.openFromPanelBuilder ?? undefined,
      enlargeEnabled: options.enlargeEnabled ?? undefined,
      switchApplication: options.switchApplication ?? undefined,
      ...analytics.getCustomDimensions().ga4,
    }

    context.$gtm.push(params)
  }

  return {
    trackImageEnhancement,
  }
}
